export function setInLocalStorage(key: string, value: any) {
    let old = localStorage[key]
    let currentValue = old && JSON.stringify(JSON.parse(old))
    var newValue = JSON.stringify(value)
    if (currentValue != newValue) {
        localStorage.setItem(key, newValue)
    }
}